<template>
  <el-dialog
    :title="title"
    :visible.sync="visible"
    @close="$_cancle"
    lock-scroll
    append-to-body
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    custom-class="greater"
  >
    <div class="content" v-loading="isLoading">
      <el-form
        ref="modifyConfig"
        label-position="right"
        :model="formData"
        :rules="rules"
      >
        <el-form-item label="品牌:" class="is-required" prop="brand">
          <el-input
            disabled
            v-model="formData.brandName"
            placeholder="单选, 必选"
            class="input-box"
          ></el-input>
          <el-button
            v-if="formType !== 'edit'"
            @click="$_selectBrand"
            class="select__btn"
            >选择</el-button
          >
        </el-form-item>

        <el-form-item label="定制系统:" class="is-required" prop="sysName">
          <el-input
            disabled
            v-model="formData.sysName"
            placeholder="请选择定制系统, 单选, 必选"
            class="input-box"
          ></el-input>
          <el-button
            v-if="formType !== 'edit'"
            @click="$_selectCustomSys"
            class="select__btn"
            >选择</el-button
          >
        </el-form-item>

        <div class="base-box" v-if="formType === 'add'">
          <div class="is-required">映射信息：</div>
          <div
            class="row-flex"
            v-for="(config, index) in formData.mappingList"
            :key="index"
          >
            <el-form-item label="供应商订阅名称:" class="is-required">
              <el-select
                v-model="formData.mappingList[index].accessKey"
                filterable
                style="width: 200px"
              >
                <!-- <el-option value label="请选择"></el-option> -->
                <el-option
                  v-for="item in subscribeList"
                  :key="item.accessKey"
                  :label="item.viewName"
                  :value="item.accessKey"
                ></el-option>
              </el-select>
            </el-form-item>

            <el-form-item
              v-if="path === 'org'"
              label="组织ID:"
              class="is-required"
            >
              <el-input
                style="width: 200px"
                v-model.trim="formData.mappingList[index].departmentId"
                class="key__input"
                placeholder="必填"
              ></el-input>
            </el-form-item>

            <el-form-item
              v-if="path === 'user'"
              label="用户ID:"
              class="is-required"
            >
              <el-input
                style="width: 200px"
                v-model.trim="formData.mappingList[index].userId"
                class="key__input"
                placeholder="必填"
              ></el-input>
            </el-form-item>

            <el-form-item label="映射ID:" class="is-required">
              <el-input
                style="width: 200px"
                v-model.trim="formData.mappingList[index].mappingId"
                class="key__input"
                placeholder="必填"
              ></el-input>
            </el-form-item>

            <el-form-item class="el-form-item-detal">
              <div
                v-if="formData.mappingList.length !== 1"
                @click="$_delectKey('mappingList', index, formData)"
                class="delete-key__btn"
              >
                <i class="cd-icon__delete"></i>
              </div>

              <div
                v-if="index === formData.mappingList.length - 1"
                @click="$_addKeys('mappingList')"
                class="add-key__btn"
              >
                <i class="cd-icon__add"></i>
                <span>添加</span>
              </div>
            </el-form-item>
          </div>
        </div>

        <!-- S 编辑状态下表单项 -->
        <el-form-item
          v-if="formType === 'edit'"
          label="供应商订阅名称:"
          class="is-required"
        >
          <el-input
            disabled
            v-model="formData.viewName"
            class="input-box"
          ></el-input>
        </el-form-item>
        <el-form-item
          v-if="formType === 'edit' && path === 'org'"
          label="组织ID:"
          class="is-required"
        >
          <el-input
            v-model="formData.departmentId"
            class="input-box"
          ></el-input>
        </el-form-item>
        <el-form-item
          v-if="formType === 'edit' && path === 'user'"
          label="用户ID:"
          class="is-required"
        >
          <el-input v-model="formData.userId" class="input-box"></el-input>
        </el-form-item>

        <el-form-item
          label="映射ID:"
          v-if="formType === 'edit'"
          class="is-required"
        >
          <el-input v-model="formData.mappingId" class="input-box"></el-input>
        </el-form-item>

        <!-- E 编辑状态下表单项 -->
      </el-form>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button class="save__btn" @click="$_submit">保存</el-button>
      <el-button class="cancel__btn" @click="$_cancle">取消</el-button>
    </div>

    <!-- S 选择品牌弹窗组件 -->
    <select-brand
      v-if="modal.show === true && modal.template === 'select-brand'"
      :title="modal.title"
      :selected="modal.data"
      @callback="$_callbackBrand"
      @close="$_close"
    ></select-brand>
    <!-- E 选择品牌弹窗组件 -->
    <!-- S 选择定制系统弹窗组件 -->
    <select-custom-company
      v-if="modal.show === true && modal.template === 'select-custom-company'"
      :title="modal.title"
      :selected="modal.data"
      @callback="$_callbackCustomSys"
      @close="$_close"
    >
    </select-custom-company>
    <!-- E 选择定制系统弹窗组件 -->
  </el-dialog>
</template>

<script>
import { getStrLength } from "@/plugins/utils";
import SelectBrand from "@/components/modal-select-brand";
import SelectCustomCompany from "@/components/modal/select-custom-company";

export default {
  name: "modal-modify-mapping",
  props: ["title", "parentData", "path"],
  data() {
    return {
      visible: false,
      isLoading: false,
      subscribeList: [],
      formData: {
        id: 0,
        brandId: 0,
        brandName: "",
        brand: {}, // 已选品牌
        sysType: "", // 定制系统
        sysName: "",
        mappingList: [
          {
            accessKey: "", // 订阅accessKey
            departmentId: "", // 组织id
            uesrId: "", // 用户id
            mappingId: "", // 映射id
          },
        ],
        viewName: "", // 供应商订阅名称
        departmentId: "", // 编辑状态下使用
        userId: "",
        mappingId: "",
      },
      modal: {
        show: false,
        title: "",
        template: "",
        data: {},
      },
      rules: {
        brand: [
          {
            validator: (rule, value, callback) => {
              if (Object.keys(value).length < 1) {
                callback(new Error("请选择品牌"));
              } else {
                callback();
              }
            },
          },
        ],
        sysName: [{ required: true, message: "请选择定制系统" }],
      },
    };
  },
  computed: {
    formType() {
      return this.formData.id > 0 ? "edit" : "add";
    },
  },
  watch: {
    "formData.brand"(val) {
      this.formData.brandId = val.brandId || 0;
      this.formData.brandName = val.brandName || "";
    },
    "formData.brandName"(val, oldVal) {
      if (oldVal !== "") {
        this.formData.mappingList.map((item) => {
          item.accessKey = "";
        });
      }
    },
  },
  methods: {
    // 保存按钮
    $_submit() {
      if (this.isLoading) return false;
      this.isLoading = true;
      this.$refs["modifyConfig"].validate((valid) => {
        if (valid) {
          let path = this.path; // 组织 -> org , 用户 -> user
          let actionName =
            path === "org" ? "saveDepartmentMapping" : "saveUserMapping";
          let postData = {};
          if (this.formType === "add") {
            let { brandId, sysType, mappingList } = this.formData;
            // 校验 必填项
            if (
              mappingList.filter((item) => item.accessKey === "").length > 0
            ) {
              $MessageBox.alert({
                content: "请选择供应商订阅名称",
              });
              this.isLoading = false;
              return false;
            }
            // 配置化 组织/用户映射
            const mappingKey = path === "org" ? "departmentId" : "userId";
            if (mappingList.filter((item) => !item[mappingKey]).length > 0) {
              $MessageBox.alert({
                content: `请填写${path === "org" ? "组织" : "用户"}ID`,
              });
              this.isLoading = false;
              return false;
            }
            if (
              mappingList.filter((item) => item.mappingId === "").length > 0
            ) {
              $MessageBox.alert({
                content: "请填写映射ID",
              });
              this.isLoading = false;
              return false;
            }
            // 校验 departmentId
            if (
              mappingList.filter((item) => item[mappingKey] !== "").length > 0
            ) {
              for (var i = 0; i < mappingList.length; i++) {
                if (getStrLength(mappingList[i][mappingKey]) > 32) {
                  $MessageBox.alert({
                    content: `${
                      path === "org" ? "组织" : "用户"
                    }ID限制16个中文字符或32个英文字符`,
                  });
                  this.isLoading = false;
                  return false;
                } else if (
                  mappingList[i][mappingKey].match(
                    /^[\u4e00-\u9fa5a-z0-9.。，,()（）【】\[\]、\\_\-—]+$/gi
                  ) == null
                ) {
                  $MessageBox.alert({
                    content: `只包含 .。，,()（）【】[]、\\_-— 以上字符`,
                  });
                  this.isLoading = false;
                  return false;
                }
              }
            }
            // 校验mappingId
            if (
              mappingList.filter((item) => item.mappingId !== "").length > 0
            ) {
              for (var i = 0; i < mappingList.length; i++) {
                if (getStrLength(mappingList[i].mappingId) > 32) {
                  $MessageBox.alert({
                    content: "映射ID限制16个中文字符或32个英文字符",
                  });
                  this.isLoading = false;
                  return false;
                } else if (
                  mappingList[i].mappingId.match(
                    /^[\u4e00-\u9fa5a-z0-9.。，,()（）【】\[\]、\\_\-—]+$/gi
                  ) == null
                ) {
                  $MessageBox.alert({
                    content: "只能包含 .。，,()（）【】[]、\\_-— 以上字符",
                  });
                  this.isLoading = false;
                  return false;
                }
              }
            }

            postData = {
              brandId,
              sysType,
              mappingList: mappingList.map((item) => {
                let obj = {
                  accessKey: item.accessKey,
                  mappingId: item.mappingId,
                };
                path === "org"
                  ? Object.assign(obj, {
                      departmentId: item.departmentId,
                    })
                  : Object.assign(obj, {
                      userId: item.userId,
                    });
                return obj;
              }),
            };
          } else if (this.formType === "edit") {
            actionName =
              path === "org" ? "updateDepartmentMapping" : "updateUserMapping";
            let { id, departmentId, userId, mappingId } = this.formData;
            const mappingKey = path === "org" ? "departmentId" : "userId";
            if (this.formData[mappingKey] === "") {
              $MessageBox.alert({
                content: `请输入${path === "org" ? "组织" : "用户"}ID`,
              });
              this.isLoading = false;
              return false;
            } else {
              if (getStrLength(this.formData[mappingKey]) > 32) {
                $MessageBox.alert({
                  content: `${
                    path === "org" ? "组织" : "用户"
                  }ID限制16个中文字符或32个英文字符`,
                });
                this.isLoading = false;
                return false;
              } else if (
                this.formData[mappingKey].match(
                  /^[\u4e00-\u9fa5a-z0-9.。，,()（）【】\[\]、\\_\-—]+$/gi
                ) == null
              ) {
                $MessageBox.alert({
                  content: "只包含 .。，,()（）【】[]、\\_-— 以上字符",
                });
                this.isLoading = false;
                return false;
              }
            }

            if (this.formData.mappingId === "") {
              $MessageBox.alert({
                content: "请输入映射ID",
              });
              this.isLoading = false;
              return false;
            } else {
              if (getStrLength(this.formData.mappingId) > 32) {
                $MessageBox.alert({
                  content: "映射ID限制16个中文字符或32个英文字符",
                });
                this.isLoading = false;
                return false;
              } else if (
                this.formData.mappingId.match(
                  /^[\u4e00-\u9fa5a-z0-9.。，,()（）【】\[\]、\\_\-—]+$/gi
                ) == null
              ) {
                $MessageBox.alert({
                  content: "只包含 .。，,()（）【】[]、\\_-— 以上字符",
                });
                this.isLoading = false;
                return false;
              }
            }

            postData = {
              id,
              mappingId,
            };
            path === "org"
              ? Object.assign(postData, {
                  departmentId,
                })
              : Object.assign(postData, {
                  userId,
                });
          }

          // 请求接口
          this.$service.post(actionName, postData).then((result) => {
            this.isLoading = false;
            if (result.$.checkResult(result, true)) {
              $MessageBox.alert({
                content: result.msg,
                onOk: () => {
                  this.visible = false;
                  this.$emit("success");
                },
              });
            }
          });
        } else {
          this.isLoading = false;
        }
      });
    },
    // 取消-关闭本弹窗
    $_cancle() {
      this.visible = false;
      this.$emit("close");
    },
    // 选择品牌按钮
    $_selectBrand() {
      let brand = JSON.parse(JSON.stringify(this.formData.brand));
      if (Object.keys(brand).length > 0) {
        this.modal.data = { ...brand };
      } else {
        this.modal.data = {
          brandName: "",
          brandId: 0,
          accessList: [],
          platformName: "",
          platformKey: "",
        };
      }
      this.modal.title = "选择品牌";
      this.modal.template = "select-brand";
      this.modal.show = true;
    },
    // 选择品牌回调
    $_callbackBrand(data) {
      let { platformName, platformKey, brandId } = data;
      this.formData.platformName = platformName;
      this.formData.platformKey = platformKey;

      if (brandId !== this.formData.brandId) {
        this.$service
          .post("subscribePaging", {
            brandId,
            pageNow: 1,
            pageSize: 100,
            status: 1,
          })
          .then((result) => {
            if (result.$.checkResult(result, true)) {
              this.subscribeList = result.data.rows.splice(0);
            }
          });
      }

      this.formData.brand = { ...data };
    },
    // 定制系统 选择 按钮
    $_selectCustomSys() {
      this.modal.data = {
        sysType: this.formData.sysType,
        sysName: this.formData.sysName,
      };
      this.modal.title = "选择定制系统";
      this.modal.template = "select-custom-company";
      this.modal.show = true;
    },
    // 选择定制系统回调
    $_callbackCustomSys(data) {
      let { sysType, sysName } = data;
      this.formData.sysType = sysType;
      this.formData.sysName = sysName;
    },
    $_addKeys(key) {
      this.formData[key].push({
        accessKey: "",
        departmentId: "",
        userId: "",
        mappingId: "",
      });
    },
    $_delectKey(key, index, formData) {
      if (this.formData.mappingList.length === 1) return false;
      $MessageBox.confirm({
        content: "确认是否进行删除?",
        onOk() {
          formData[key].splice(index, 1);
        },
      });
    },
    // 关闭本页面发起的弹窗
    $_close() {
      this.modal.show = false;
      this.modal.template = "";
      this.modal.title = "";
      this.modal.data = {};
    },
  },
  created() {
    if (Object.keys(this.parentData).length > 0) {
      for (const [key, value] of Object.entries(this.parentData)) {
        if (this.formData.hasOwnProperty(key)) {
          this.formData[key] = value;
        }
      }
      let { brandId, brandName } = this.parentData;
      this.formData.brand = {
        brandId,
        brandName,
      };
    }
  },
  mounted() {
    this.visible = true;
  },
  components: {
    SelectBrand,
    SelectCustomCompany,
  },
};
</script>
<style lang="scss" scoped>
.content {
  height: 100%;
  padding: 20px 20px;
  .title {
    height: 32px;
    color: #384e8c;
    font-size: 14px;
    font-weight: 700;
  }
}
.input-box {
  width: 440px;
}
.select__btn {
  margin-left: 8px;
}
.input-tips {
  margin-left: 10px;
}
//映射信息
.base-box {
  padding-top: 10px;
  .row-flex {
    display: flex;
    padding-left: 30px;
    .el-form-item {
      margin-right: 30px;
    }
  }
}
.is-required {
  color: #68768a;
  vertical-align: middle;
  font-size: 12px;
  line-height: 28px;
  padding-bottom: 10px;
}
.key__input {
  width: 120px;
  margin: {
    right: 10px;
  }
}
.delete-key__btn,
.add-key__btn {
  height: 24px;
  line-height: 24px;
  padding: 0 5px;
  background: none;
  border: 0;
  margin: 0;
  color: #68768a;
  display: inline-block;
}
.delete-key__btn {
  .cd-icon__delete {
    width: 10px;
    height: 10px;
    background: url(~@/assets/images/icon-delete.png) no-repeat center;
    &:hover,
    &:focus {
      background: url(~@/assets/images/icon-delete__hover.png) no-repeat center;
    }
  }
  + .add-key__btn {
    margin: {
      left: 0;
    }
  }
}
.key__radio {
  + .add-key__btn {
    margin: {
      left: 10px;
    }
  }
}
.add-key__btn {
  .cd-icon__add {
    width: 10px;
    height: 10px;
    margin-right: 5px;
    background: url(~@/assets/images/icon-add.png) no-repeat center;
  }
  &:hover,
  &:focus {
    border-radius: 4px;
    background-color: #68768a;
    color: #fff;
    .cd-icon__add {
      background: url(~@/assets/images/icon-add__hover.png) no-repeat center;
    }
  }
}
.el-form-item-detal {
  margin-top: 30px;
}
</style>
